var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"asc-descriptions-item"},[_c('asc-parameter-alert-item',{attrs:{"status":_vm.status,"simple":""}}),_c('span',{staticClass:"asc-descriptions-item--label"},[_vm._v("; Value: "+_vm._s(_vm.value))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }